import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Fade } from 'react-reveal';
import Loading from './../components/loading';
import MetaTags from 'react-meta-tags';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Image from 'react-bootstrap/Image'
import Sidebar from '../components/sidebar'
import WhyUs from "./whyus";
import Prices from "./prices";
import Rates from './rates';
import Dictionary from './dictionary';
import NotFound from './404';

const ContentStyles = styled.div`
  
`;

class ContentPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      host: window.location.hostname
    };
  }

  componentDidMount() {
    fetch("/json/content.json?v=" + process.env.REACT_APP_SITE_VERSION)
      .then(res => res.json())
      .then(
        (result) => {
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            this.setState({
              isLoaded: true,
              items: result
            });
          }.bind(this), 1000);
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
    )
    switch (window.location.hostname) {
      case "localhost":
        this.setState({ host: "http://localhost" });
        break;
      case "mortgagetest.emlakkatilim.com.tr":
        this.setState({ host: "https://mortgagetest.emlakkatilim.com.tr" });
        break;
      case "www.emlakkatilim.com.tr":
        this.setState({ host: "https://mortgage.emlakkatilim.com.tr" });
        break;
      default:
        this.setState({ host: "https://mortgage.emlakkatilim.com.tr" });
        break;
    }
  }

  render() {
    const { error, isLoaded, items } = this.state;
    const { contentId } = this.props.match.params;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Loading />;
    } else {
      const counting = items.filter(contents => contents.permalink === contentId && contents.isActive === true).length;
      if (counting === 0) {
        return (
          <>
            <Redirect to="/404" />
          </>
        );
      }
      return (
        <>

          {
            items.filter(contents => contents.permalink === contentId)
              .map((contents, i) => {

                const htmlString = contents.content;

                return (
                  <div key={i}>
                    <MetaTags>
                      <title>{contents.name} | Emlak Katılım Mortgage</title>
                      <meta name="description" content={contents.summary} />
                      {
                        contents.index === 0 ?
                          <meta name="robots" content="noindex, nofollow" />
                          :
                          <meta name="robots" content="all" />
                      }
                      <meta property="og:title" content={contents.name} />
                      <meta property="og:type" content="website" />
                      <meta property="og:url" content={`${this.state.host}${this.props.location.pathname}`} />
                      <meta property="og:image" content={`${this.state.host}${contents.facebookimg}`} />
                      <meta property="og:image:width" content="1200" />
                      <meta property="og:image:height" content="630" />
                      <meta property="og:description" content={contents.summary} />
                      <meta property="twitter:card" content="summary" />
                      <meta property="twitter:site" content="@tremlakkatilim" />
                      <meta property="twitter:title" content="Emlak Katılım Mortgage" />
                      <meta property="twitter:url" content={`${this.state.host}${this.props.location.pathname}`} />
                      <meta property="twitter:image" content={`${this.state.host}${contents.twitterimg}`} />
                      <meta property="twitter:description" content={contents.summary} />
                    </MetaTags>
                    <ContentStyles>
                      <Jumbotron className="subpageHeader" fluid>
                        <Fade>
                          <Container>
                            <h1>{contents.name}</h1>
                            <Breadcrumb>
                              {contents.breadcrumb.map((breadcrumbs, i) => (
                                <Breadcrumb.Item key={i} href={breadcrumbs.permalink}>
                                  {breadcrumbs.name}
                                </Breadcrumb.Item>
                              ))}
                            </Breadcrumb>
                          </Container>
                        </Fade>
                      </Jumbotron>
                      <Container>
                        <Row>
                          <Col className="subpageContent" sm={9}>
                            {
                              contents.headimage !== "" && (
                                <Image className="mb-3" src={contents.headimage} alt={contents.name} fluid />
                              )
                            }
                            <Fade bottom cascade>
                              <article dangerouslySetInnerHTML={{ __html: htmlString }}>
                              </article>
                            </Fade>
                          </Col>
                          <Col sm={3}>
                            <Sidebar page={contents.category} />
                          </Col>
                        </Row>
                      </Container>
                    </ContentStyles>
                  </div>
                );
              })
          }
        </>
      );
    }
  }
}

const Contents = () => {

  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/neden-biz" component={WhyUs} />
          <Route exact path="/urun-ve-hizmet-ucretleri" component={Prices} />
          <Route exact path="/oranlarimiz" component={Rates} />
          <Route exact path="/mortgage/mortgage-sozlugu" component={Dictionary} />
          <Route path="/neden-biz/:contentId" component={ContentPage} />
          <Route path="/mortgage/:contentId" component={ContentPage} />
          <Route path="/blog/:contentId" component={ContentPage} />
          <Route path="/konut-satis-istatistikleri/:contentId" component={ContentPage} />
          <Route path="/ev-alim-rehberi/:contentId" component={ContentPage} />
          <Route path="/konut-finansman-urunlerimiz/:contentId" component={ContentPage} />
          <Route path="/sigortacilik-islemleri/:contentId" component={ContentPage} />
          <Route path="" component={NotFound} status={404} />
          <Route path="/:contentId" component={ContentPage} />
        </Switch>
      </Router>
    </>
  );
};

export default Contents;